export default __webpack_public_path__ + "static/media/near_white.903f90b1.svg";